import React, { useEffect, useState } from 'react';

import closeIcon from '../../../../../../Assets/images/close-icon.svg';
import Loader from "../../../../../../Context/Loader/Loader";
import apiClient from "../../../../../../Config/apiClient";
import { showErrorToast, showSuccessToast } from "../../../../../../Context/Toaster/Toaster";

const truckPath = process.env.REACT_APP_TC_TRUCK_BASE_PATH;
const driverPath = process.env.REACT_APP_TC_DRIVERS_BASE_PATH;

const AssignModal = ({ onClose, job }) => {

    const isEditMode = job?.mode === "edit";

    const [isLoading, setIsLoading] = useState(false);
    const [drivers, setDrivers] = useState([]);
    const [trucks, setTrucks] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState("");
    const [selectedTruck, setSelectedTruck] = useState("");
    const [errors, setErrors] = useState({ driver: "", truck: "" });
    const [isLimitReached, setIsLimitReached] = useState(false);

    useEffect(() => {
        fetchDrivers();
        fetchTrucks();

        if (isEditMode) {
            setSelectedDriver(job?.driver_id || "");
            setSelectedTruck(job?.truck_id || "");
        } else if (job && job.num_trucks_applied >= job.num_trucks_required) {
            setIsLimitReached(true);
        }
    }, [job]);

    const fetchDrivers = async () => {
        try {
            const response = await apiClient.post(`${driverPath}/list`, {});
            setDrivers(response.data.data || []);
        } catch (error) {
            console.error("Error fetching drivers:", error);
            showErrorToast("Failed to load drivers.");
        }
    };

    const fetchTrucks = async () => {
        try {
            const response = await apiClient.post(`${truckPath}/all`, {});
            setTrucks(response.data.data || []);
        } catch (error) {
            console.error("Error fetching trucks:", error);
            showErrorToast("Failed to load trucks.");
        }
    };

    useEffect(() => {
        fetchDrivers();
        fetchTrucks();
    }, []);

    const handleAssign = async () => {
        let hasError = false;
        const newErrors = { driver: "", truck: "" };

        if (!selectedDriver) {
            newErrors.driver = "Driver is required";
            hasError = true;
        }
        if (!selectedTruck) {
            newErrors.truck = "Truck is required";
            hasError = true;
        }

        setErrors(newErrors);
        if (hasError) return;

        setIsLoading(true);
        try {
            const payload = {
                job_id: job.id,
                truck_id: selectedTruck,
                driver_id: selectedDriver,
            };

            let response;

            if (isEditMode) {
                payload.assignment_id = job.assignment_id;
                response = await apiClient.put(`${truckPath}/edit-assign`, payload);
            } else {
                response = await apiClient.post(`${truckPath}/assign`, payload);
            }

            if (response.data.status === "SUCCESS") {
                showSuccessToast(
                    isEditMode
                        ? "Truck and driver assignment updated successfully!"
                        : "Truck and driver assigned successfully!"
                );

                const updatedJob = {
                    ...job,
                    num_trucks_applied: job.num_trucks_applied + 1,
                };

                onClose(updatedJob);
            } else {
                showErrorToast(response.data.message);
            }
        } catch (error) {
            const message = error.response?.data?.message || "Something went wrong";
            showErrorToast(message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="cprofile-overlay" id="cprofile-modal">
            <div className="aprofile-content assign-modal">
                <div className="cpf-top">
                    <h2> {isEditMode ? `Edit Job Assignment : ${job?.job_name || ''}` : `Job Assignment : ${job?.job_name || ''}`} </h2>
                    <button className="m-close" onClick={onClose}>
                        <img src={closeIcon} alt="close" />
                    </button>
                </div>

                <div className='asinner-split'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='cp-split'>
                                <label style={{ fontWeight: '600', display: 'block', marginBottom: '3px' }}>Description</label>
                                <p style={{ margin: 0 }}>{job?.job_description || ""}</p>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='cp-split'>
                                <label style={{ fontWeight: '600', display: 'block', marginBottom: '3px' }}>Job Type</label>
                                <p style={{ margin: 0 }}>{job?.job_type || ''}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='cp-split'>
                                <label style={{ fontWeight: '600', display: 'block', marginBottom: '3px' }}>Rate</label>
                                <p style={{ margin: 0 }}>{job?.payment_rate ? `$${job.payment_rate}/${job.payment_type}` : ''}</p>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='cp-split'>
                                <label style={{ fontWeight: '600', display: 'block', marginBottom: '3px' }}>Driver</label>
                                <select className='common-select ' value={selectedDriver} onChange={(e) => { setSelectedDriver(e.target.value); setErrors(prev => ({ ...prev, driver: "" })); }} style={{ width: "98%", border: `1px solid ${errors.driver ? 'red' : '#9e9e9e'}` }} >
                                    <option value="">--Select--</option>
                                    {drivers.map((driver) => (
                                        <option key={driver.id} value={driver.id}>
                                            {driver.first_name} {driver.last_name}
                                        </option>
                                    ))}
                                </select>
                                {errors.driver && <div className='assign-error'>{errors.driver}</div>}
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='cp-split'>
                                <label style={{ fontWeight: '600', display: 'block', marginBottom: '3px' }}>Truck</label>
                                <select className='common-select ' value={selectedTruck} onChange={(e) => { setSelectedTruck(e.target.value); setErrors(prev => ({ ...prev, truck: "" })); }} style={{ border: `1px solid ${errors.truck ? 'red' : '#9e9e9e'}` }}>
                                    <option value="">--Select--</option>
                                    {trucks.map((truck) => (
                                        <option key={truck.truck_id} value={truck.truck_id}>
                                            T-{truck.truck_id} : {truck.vehicle_no}
                                        </option>
                                    ))}
                                </select>
                                {errors.truck && <div className='assign-error'>{errors.truck}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <button className="update-button" disabled={isLoading} onClick={handleAssign}>
                    {isLoading ? <Loader /> : isEditMode ? "Update" : "Assign"}
                </button>
            </div>
        </div>
    );
};

export default AssignModal;